import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

const useHandleAuthorizeError = (
  setAccessToken: Env.SetState<string | null | undefined>,
) => {
  const { widget } = useWidgetContext();

  const handleAuthorizeError = () => {
    localStorage.removeItem(
      `whatcrmWidgetAccessToken${widget.instance_chat_key}`,
    );

    setAccessToken(undefined);
  };

  return handleAuthorizeError;
};

export default useHandleAuthorizeError;
